import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'colmec-login-reset-password-wrapper',
    templateUrl: './colmec-login-reset-password-wrapper.component.html',
    styleUrls: ['./colmec-login-reset-password-wrapper.component.scss'],
    standalone: false
})
export class ColmecLoginResetPasswordWrapperComponent implements OnInit {
  isLogin = true;
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.isLogin = this.router.url.startsWith('/login');
  }
}
